import { render, staticRenderFns } from "./Archivelistview.vue?vue&type=template&id=669c1aaa"
import script from "./Archivelistview.vue?vue&type=script&lang=js"
export * from "./Archivelistview.vue?vue&type=script&lang=js"
import style0 from "./Archivelistview.vue?vue&type=style&index=0&id=669c1aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports